<template>
  <div class="mod-config">
    <div>总人数:{{count}}</div>
    <el-form :inline="true"
             :model="dataForm"
             @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.key"
                  placeholder="请输入会员电话"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList"
              border
              v-loading="dataListLoading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection"
                       header-align="center"
                       align="center"
                       width="50">
      </el-table-column>
      <el-table-column prop="id"
                       header-align="center"
                       align="center"
                       label="id">
      </el-table-column>
      <!-- <el-table-column prop="openid"
                       header-align="center"
                       align="center"
                       label="openid">
      </el-table-column> -->
      <el-table-column prop="phone"
                       header-align="center"
                       align="center"
                       label="电话">
      </el-table-column>
      <el-table-column prop="type"
                       header-align="center"
                       align="center"
                       label="用户类型">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.type===0"
                  type="error">普通用户</el-tag>
          <el-tag v-if="scope2.row.type===1"
                  type="success">Vip</el-tag>
          <el-tag v-if="scope2.row.type===2"
                  type="error">黑名單</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rzstatus"
                       header-align="center"
                       align="center"
                       label="认证状态">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.rzstatus===0"
                  type="error">未认证</el-tag>
          <el-tag v-if="scope2.row.rzstatus===1"
                  type="success">已经认证</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name"
                       header-align="center"
                       align="center"
                       label="名字">
      </el-table-column>
      <el-table-column prop="gsname"
                       header-align="center"
                       align="center"
                       label="公司名字">
      </el-table-column>
      <el-table-column prop="gszhizhao"
                       header-align="center"
                       align="center"
                       label="公司执照">
        <!-- <template slot-scope="scope2">
          <img :src="scope2.row.gszhizhao"
               style="width:100px;height:100px" />
        </template> -->
      </el-table-column>
      <el-table-column prop="vipdqtime"
                       header-align="center"
                       align="center"
                       label="会员到期时间">
      </el-table-column>
      <el-table-column prop="headurl"
                       header-align="center"
                       align="center"
                       label="头像" >
        <template slot-scope="scope2">
          <img :src="scope2.row.headurl"
               style="width:100px;height:100px" />
        </template>
      </el-table-column>
      <el-table-column prop="bjcishu"
                       header-align="center"
                       align="center"
                       label="报价次数">
      </el-table-column>
      <el-table-column prop="createtime"
                       header-align="center"
                       align="center"
                       label="创建时间">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       width="150"
                       label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
          <el-button type="text"
                     size="small"
                     @click="deleteHandle(scope.row.id)">设置黑名单</el-button>
          <el-button type="text"
                     size="small"
                     @click="quxiaoheimingdan(scope.row.id)">取消黑名单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle"
                   :current-page="pageIndex"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="pageSize"
                   :total="totalPage"
                   layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible"
                   ref="addOrUpdate"
                   @refreshDataList="getDataList"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from '@/components/jguser-add-or-update'
export default {
  data () {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: true,
      dataListSelections: [],
      addOrUpdateVisible: false,
      count:0
    }
  },
  components: {
    AddOrUpdate
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 取消黑名单
    quxiaoheimingdan (id) {
      this.$http({
        url: this.global.apiUrl + '/jxjg/jguser/quxiaoheimingdan',
        method: 'post',
        params: {
          'id': id
        }
      }).then((data) => {
        data = data.body
        if (data && data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jguser/list',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'key': this.dataForm.key
        }
      }).then((data) => {
        console.log("data",data)
        if (data && data.body) {
          this.dataList = data.body.page.list
          this.totalPage = data.body.page.totalCount
          this.count = data.body.page.totalCount
        } else {
          this.dataList = []
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 设置黑名单
    deleteHandle (id) {
      this.$http({
        url: this.global.apiUrl + '/jxjg/jguser/heimingdan',
        method: 'post',
        params: {
          'id': id
        }
      }).then((data) => {
        data = data.body
        if (data && data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/jguser.vue